import styled from 'styled-components'

export const BannerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  width: 100vw;
  background: linear-gradient(90deg, #f08732 0%, #fdd96d 100%);
  height: fit-content;
  padding-block: 10px;
  z-index: 2;
  @media (max-width: 488px) {
    flex-wrap: wrap;
  }
`

export const Text = styled.span`
  font-size: 14px;
  font-weight: bold;
  font-family: Sora, sans-serif;
  color: #030852;
  @media (max-width: 768px) {
    font-size: 10px;
  }
`
export const LinkPromotion = styled.a`
  font-size: 14px;
  font-family: Sora, sans-serif;
  color: rgb(255, 255, 255);
  background: #030852;
  padding-inline: 5px;
  margin-inline: 5px;
  font-weight: bold;
  @media (max-width: 768px) {
    font-size: 10px;
  }
`
